import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import Spinner from "../../components/FormElements/Spinner";
import { getOffices } from "../../features/location/officeSlice";
import { unwrapResult } from "@reduxjs/toolkit";
import { OfficeWeekView } from "../../Bookings/components/OfficeWeekView";
import "./Admin.css";
import { AlertDialog } from "../../components/UIElements/AlertDialog";
import { isIndexValid } from "./utils";
import { SHARED_ROUTES } from "../../config/routes";

const INDEX_NOT_READY = 100;

export const Admin = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();


  const { offices, isLoading, isError } = useSelector((state) => state.office);

  const searchParams = new URLSearchParams(location.search);
  const locationId = searchParams.get("locationId");
  const year = searchParams.get("year");

  const [activeTabIndex, setActiveTabIndex] = useState(INDEX_NOT_READY); // make sure we don't display first tab before data is loaded

  useEffect(() => {
    dispatch(getOffices())
      .then(unwrapResult)
      .then((result) => {
        if (locationId && result) {
          // Find the index of the office that matches the locationId
          const foundIndex = result.findIndex(
            (office) => office.location_id === Number(locationId)
          );
          if (foundIndex !== -1) {
            setActiveTabIndex(foundIndex); // Set the active tab based on locationId
          }
        } else if (result.length > 0) {
          setActiveTabIndex(0); // Default to the first office if no locationId is provided (first site load)
        }
      })
      .catch((error) => {
        console.error("GetOffices Dispatch Error: ", error);
      });
  }, [dispatch, locationId]);

  const handleTabChange = (index) => {
    setActiveTabIndex(index);
    const selectedLocationId = offices[index].location_id;

    // Update the URL with the new locationId parameter
    const searchParams = new URLSearchParams({
      locationId: selectedLocationId,
    });
    navigate(`${SHARED_ROUTES.home}?${searchParams.toString()}`);
  };

  if (isLoading) return <Spinner />;
  if (isError)
    return <AlertDialog variant="error" message="Error loading office list" />;
  if (activeTabIndex === INDEX_NOT_READY || !isIndexValid(activeTabIndex, offices, locationId)) return <Spinner />;

  return (
    <Tabs
      colorScheme="red"
      fontWeight="bold"
      index={activeTabIndex} // Set the current tab index
      onChange={handleTabChange} // Update active tab when changed
    >
      <TabList>
        {offices.map((e) => (
          <Tab key={e.location_id}>{e.location_name}</Tab>
        ))}
      </TabList>
      <TabPanels>
        {offices.map((e, index) => (
          <TabPanel bg="white" mb="2em" key={e.location_id}>
            {index === activeTabIndex && (
              <OfficeWeekView locationId={e.location_id} name={e.location_name} selectedYear={year} />
            )}
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
};
